import React, { Component } from 'react';
import DetailsComponent from '../../Components/Book/Details/Details';
import defaultDetails from '../../Constants/details';

export default class ShootType extends Component {
	render(): React.ReactElement {
		return (
			<DetailsComponent data={defaultDetails} />
		);
	}
}
